import React from 'react';

const isFirefox = (navigator.userAgent || '').indexOf('Firefox') > -1;
const chromeUrl = 'https://chrome.google.com/webstore/detail/tabby-cat/mefhakmgclhhfbdadeojlkbllmecialg?hl=en';
const firefoxUrl = 'https://addons.mozilla.org/en-US/firefox/addon/tabby-cat-friend/';

function InstallButton(props) {
	return (
		<a className={props.classNames}
			href={isFirefox ? firefoxUrl : chromeUrl}
			onMouseOver={props.hoverOnButton}
			onMouseOut={props.hoverOffButton}>
			{props.ctaText}
		</a>
	);
}

// <span className="install-button--extra-text"> for hidden text on mobile

InstallButton.defaultProps = {
	ctaText: <span>+ Add to {isFirefox ? 'Firefox' : 'Chrome'}</span>,
};

export default InstallButton;



// WEBPACK FOOTER //
// ./src/components/Site/InstallButton.js